var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPlayer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_2",
    "data-name": "Lag 2",
    width: 18,
    height: 17.98,
    viewBox: "0 0 18 17.98",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Group_3545",
    "data-name": "Group 3545",
    d: "M6.168,16.34H11.8a.82.82,0,0,1,.82.82h0a.82.82,0,0,1-.82.82H6.168a.82.82,0,0,1-.82-.82h0A.82.82,0,0,1,6.168,16.34ZM15,15H3a3.008,3.008,0,0,1-3-3V3A3,3,0,0,1,3,0H15a3,3,0,0,1,3,3v9a3,3,0,0,1-3,3ZM7.7,4.105a.7.7,0,0,0-.7.7v5.385a.7.7,0,0,0,.7.7.74.74,0,0,0,.388-.119l4.038-2.7a.7.7,0,0,0,0-1.164L8.088,4.217A.7.7,0,0,0,7.7,4.107Z",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlayer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/player.6ac354b9.svg";
export { ForwardRef as ReactComponent };